// Publications.js – Professional Publications Section
import React from "react";

const Publications = () => {
  const publications = [
    {
      title:
        "Frequency Band Allocation Using Hierarchical Reinforcement Learning for Efficient Wireless Resource Management",
      authors: "Ketema, T. G., Chalise, B., and Mahmood, A.",
      conference:
        "MILCOM 2025 – IEEE Military Communications Conference (MILCOM), 2025, pp. 606–611.",
      link: "https://doi.org/10.1109/MILCOM64451.2025.11309913",
      abstract: `
A typical objective of frequency band allocation to cellular users in a multi-cell network environment is to maximize system sum-rate in the presence of inter-cell interference, while ensuring that users within the same cell do not experience interference and each user is assigned to only one base station. This is a challenging combinatorial optimization problem, and its computational complexity increases significantly with increasing network size. This paper proposes a novel approach using Hierarchical Reinforcement Learning (HRL) to efficiently allocate frequency bands while maximizing system sum-rate. The proposed model divides the task into high- and low-level policies, enhancing both global resource management and local interference control. Simulation results demonstrate that the HRL-based method outperforms traditional allocation strategies in terms of the trade-off between throughput and computational efficiency.
`
    },

    {
      title:
        "Big Data-Driven Collaborative Channel Estimation in RIS Communications: A DNN Approach for Optimized Performance",
      authors:
        "Ketema, T. G., Xu, D., Moreira, J., Mumtaz, R., and Yu, K.",
      conference:
        "IEEE International Conference on Communications (ICC), Denver, CO, USA, pp. 690–695, June 2024.",
      link: "https://doi.org/10.1109/ICC51166.2024.10622548",
      abstract: `
In recent years, the field of wireless communications supported by reconfigurable intelligent surface (RIS) has emerged as a cutting-edge area of research. A primary challenge in this domain is the accurate and efficient channel estimation, especially under conditions of low pilot overhead. This work introduces a system model and a DNN-based channel estimation solution with the goal of improving the efficiency and accuracy of channel estimation under low pilot overhead in RIS-assisted communication systems. A significant highlight is the reduction in pilot overhead required for downlink channel estimation, which was accomplished by leveraging statistical correlation among different users' channels. Mainly, the research emphasizes the collaborative training of the DNN model, where both the Base Station (BS) and users iteratively exchange data and model updates, resulting in a jointly learned model that offers improved performance. The findings show that the proposed approach not only substantially reduces the pilot overhead but also ensures efficient channel state information learning, paving the way for more efficient RIS-assisted wireless communications. Simulation outcomes reveal that, when compared with conventional estimation techniques like least squares (LS) and minimum mean square error (MMSE), the suggested deep neural network (DNN) model attains enhanced estimation performance while reducing the required pilot overhead for all users.
`
    }
  ];

  return (
    <section id="publications" className="w-full">
      <div className="bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">Publications</h2>

        <div className="space-y-10">
          {publications.map((pub, index) => (
            <div
              key={index}
              className="border-l-4 border-purple-600 pl-6 pb-4 hover:bg-gray-50 transition duration-300 rounded-lg"
            >
              <h3 className="text-xl font-semibold text-gray-900">{pub.title}</h3>

              <p className="text-gray-700 mt-1">{pub.authors}</p>

              <p className="text-sm text-gray-500 italic mt-1">
                {pub.conference}
              </p>

              <a
                href={pub.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 font-medium hover:underline mt-1 inline-block"
              >
                View Publication ↗
              </a>

              {/* Abstract Section */}
              <div className="mt-4 bg-gray-100 p-5 rounded-md border border-gray-200">
                <h4 className="text-md font-semibold text-gray-800 mb-2">
                  Abstract
                </h4>
                <p className="text-sm text-gray-700 whitespace-pre-line leading-relaxed">
                  {pub.abstract}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Publications;
